/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Key_Will_RemoveInputs */

const en_ai_key_will_remove = /** @type {(inputs: Ai_Key_Will_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removed when you save`)
};

const de_ai_key_will_remove = /** @type {(inputs: Ai_Key_Will_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird beim Speichern entfernt`)
};

/**
* | output |
* | --- |
* | "Removed when you save" |
*
* @param {Ai_Key_Will_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_will_remove = /** @type {((inputs?: Ai_Key_Will_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_Will_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_will_remove(inputs)
	return en_ai_key_will_remove(inputs)
});